// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#D62828" },
    secondary: { main: "#FFCA28" },
    warning: { main: "#FFCA28" },
    text: { primary: "#1F1F1F" },
    background: { default: "#FFFFFF", paper: "#FFFFFF" },
    // optional custom bucket:
    jam: { red: "#D62828", gold: "#FFCA28", brown: "#8B2B17" },
  },
  typography: {
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
    h1: { fontSize: "2.5rem", fontWeight: 700, lineHeight: 1.2 },
    h2: { fontSize: "1.75rem", fontWeight: 700 },
    h3: { fontSize: "1.25rem", fontWeight: 700 },
    body1: { fontSize: "1rem", lineHeight: 1.6 },
    body2: { fontSize: ".9rem", lineHeight: 1.5 },
    button: { fontWeight: 700, textTransform: "none" },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 12, paddingInline: 16, paddingBlock: 10 },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiAppBar: {
      styleOverrides: { root: { background: "#fff", color: "#111" } },
    },
  },
});

export default theme;
